/*
  Renk varyantı için temiz URL — /products/{handle}/{renk-slug}

  NEDEN
  Tema varyant değişince adresi `?variant=52838418743509` yapıyordu; paylaşılabilir
  ama okunmuyor ve SEO için bir şey ifade etmiyor. Shopify ürün handle'ından sonra
  TEK bir fazladan yol parçasını tolere ediyor (ölçüldü: /products/x/light → 200,
  /products/x/light/a/b → 404), dolayısıyla rengi yola yazabiliyoruz.

  Canonical'a dokunmuyoruz: Shopify /products/x/light sayfasında bile canonical'ı
  /products/x olarak basıyor, yani duplicate content riski yok (ClickUp 86eyfcap7).

  NE YAPIYOR
  1. Sayfa açılışında yoldaki renk parçasını okuyup eşleşen swatch'ı seçiyor.
     Sunucu bu URL'de varyantı ÖNCEDEN SEÇMİYOR — seçimi burada yapmak zorundayız.
  2. Renk değişince adres çubuğunu yeniliyor.

  NEDEN TEMA JS'İNE DOKUNMUYORUZ
  İlk sürüm variant-select.js'teki _updateURL'i çağırıyordu. İki sorun çıktı:
  (a) _updateURL, radio'lar tazelenmeden önce koştuğu için bir önceki rengi yazıyordu;
  (b) o kod Alpine bileşeninin içinde ve Alpine bu temada ilk kullanıcı etkileşiminde
  yükleniyor. Bunun yerine document seviyesinde 'change' dinliyoruz: tıklanan radio'nun
  kendi değerini okuduğumuz için tazelik sorunu yok ve Alpine'ı beklemiyoruz.
  Tema dosyası değişmediği için Shopify tema güncellemeleri de bunu ezmiyor.

  NEDEN name="Color" İLE ARAMIYORUZ
  Tema input adını bölüm ekiyle üretiyor ve sonuna satır sonu koyuyor:
  name="Color-1\n". Sabit `input[name="Color"]` seçicisi hiçbir şey yakalamaz.
  Bunun yerine .variant-selects-main içindeki radio'ların DEĞERLERİ handle'lanıp
  karşılaştırılıyor.
*/
(function () {
  // Shopify'ın handleize'ı ile aynı sonucu üretmeli; Türkçe harfler de çevriliyor.
  var HARF = { 'ı':'i', 'İ':'i', 'ş':'s', 'Ş':'s', 'ğ':'g', 'Ğ':'g',
               'ö':'o', 'Ö':'o', 'ü':'u', 'Ü':'u', 'ç':'c', 'Ç':'c' };

  function handleize(metin) {
    return String(metin)
      .replace(/[ıİşŞğĞöÖüÜçÇ]/g, function (h) { return HARF[h]; })
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  /*
    Sayfada .variant-selects-main sınıfını taşıyan İKİ kap var: önce hızlı görünüm
    (…__quick-view), sonra asıl ürün formu (…__main). Eskiden querySelector ile
    ilkini alıyorduk; az renkli üründe hızlı görünüm de radio bastığı için tesadüfen
    çalışıyor, ÇOK RENKLİ üründe hızlı görünüm <select>'e düştüğü için hiç radio
    bulunamıyordu — temiz URL 24 renkli rujda sessizce çalışmıyordu (ölçüldü).
    Bu yüzden radio içeren ve __main olan kabı seçiyoruz.
  */
  function anaKok() {
    var hepsi = Array.prototype.slice.call(document.querySelectorAll('.variant-selects-main'));
    if (!hepsi.length) return null;
    var radyolu = hepsi.filter(function (k) {
      return k.querySelector('input[type="radio"]');
    });
    var liste = radyolu.length ? radyolu : hepsi;
    for (var i = 0; i < liste.length; i++) {
      if (liste[i].querySelector('[id*="__main"]')) return liste[i];
    }
    // __main bulunamazsa sondaki: asıl form DOM'da hızlı görünümden sonra geliyor.
    return liste[liste.length - 1];
  }

  function renkGirdileri() {
    var kok = anaKok();
    if (!kok) return [];
    return Array.prototype.slice.call(kok.querySelectorAll('input[type="radio"]'));
  }

  function urunHandle() {
    var p = window.location.pathname.split('/').filter(Boolean);
    var i = p.indexOf('products');
    return i >= 0 && p[i + 1] ? p[i + 1] : null;
  }

  function yoldakiRenk() {
    var p = window.location.pathname.split('/').filter(Boolean);
    var i = p.indexOf('products');
    return i >= 0 && p[i + 2] ? p[i + 2].toLowerCase() : null;
  }

  function temizYol(renkDegeri) {
    var handle = urunHandle();
    if (!handle) return null;
    var slug = handleize(renkDegeri);
    if (!slug) return null;
    var p = window.location.pathname.split('/').filter(Boolean);
    var i = p.indexOf('products');
    var temel = '/' + p.slice(0, i + 2).join('/');
    return temel + '/' + slug + window.location.search + window.location.hash;
  }

  /*
    Renk grubunun input adı; renk olmayan seçeneklerde (Beden vb.) URL'i bozmayalım.
    Eskiden ilk radio'nun adını dönüyordu: renk İKİNCİ seçenek olsaydı beden grubunu
    renk sanıp bedeni URL'e yazardı. Artık data-renk-index'inci ayrı grubu alıyoruz.
  */
  function renkGrubuAdi() {
    var kok = anaKok();
    if (!kok || kok.dataset.renkIndex === undefined) return null;
    var i = parseInt(kok.dataset.renkIndex, 10);
    if (isNaN(i)) return null;
    var adlar = [];
    var girdiler = renkGirdileri();
    for (var j = 0; j < girdiler.length; j++) {
      if (adlar.indexOf(girdiler[j].name) === -1) adlar.push(girdiler[j].name);
    }
    return adlar[i] === undefined ? null : adlar[i];
  }

  function adresiGuncelle(renkDegeri) {
    var yol = temizYol(renkDegeri);
    if (!yol || yol === window.location.pathname + window.location.search + window.location.hash) return;
    window.history.replaceState({}, '', yol);
  }

  // Açılışta yoldaki rengi uygula.
  function acilistaUygula() {
    var hedef = yoldakiRenk();
    if (!hedef) return;

    var girdiler = renkGirdileri();
    if (!girdiler.length) return;

    for (var i = 0; i < girdiler.length; i++) {
      if (handleize(girdiler[i].value) !== hedef) continue;
      if (girdiler[i].checked) return;          // sunucu zaten seçmişse dokunma
      girdiler[i].checked = true;
      girdiler[i].dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
  }

  /*
    Varyant seçici Alpine ile geç basılıyor; DOMContentLoaded anında radio'lar
    henüz yokken bir kez deneyip pes etmek yetmiyor. Kısa süre gözlüyoruz.
  */
  function baslat() {
    if (renkGirdileri().length) { acilistaUygula(); return; }
    var gozlemci = new MutationObserver(function () {
      if (!renkGirdileri().length) return;
      gozlemci.disconnect();
      acilistaUygula();
    });
    gozlemci.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { gozlemci.disconnect(); }, 8000);
  }

  /*
    Renk değişimini document seviyesinde yakalıyoruz. Radio'lar Alpine tarafından
    yeniden basıldığı için elemana doğrudan dinleyici bağlamak kalıcı olmuyor;
    olay yükselmesi (bubbling) her tazelemeden sonra da çalışır.
  */
  function degisimiDinle() {
    document.addEventListener('change', function (olay) {
      var g = olay.target;
      if (!g || g.type !== 'radio') return;

      var kok = anaKok();
      if (!kok || !kok.contains(g)) return;              // hızlı görünüm vb. sayılmaz
      if (kok.dataset.renkIndex === undefined) return;   // ürünün renk seçeneği yok

      // Renk grubunun input adını, seçenek sırasından değil ilk radio'dan alıyoruz;
      // ad "<Seçenek>-<pozisyon>" biçiminde ve sonunda satır sonu taşıyor.
      var grup = renkGrubuAdi();
      if (grup !== null && g.name !== grup) return;      // beden vb. başka bir seçenek

      adresiGuncelle(g.value);
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { baslat(); degisimiDinle(); });
  } else {
    baslat();
    degisimiDinle();
  }
})();
